import { useQuery } from '@apollo/react-hooks';

import { getSingleProp } from 'src/utils/lib/graphql';
import { GOOGLE_AUTHORIZATION_LINK_QUERY } from './schema';

export default () => {
  const { data, error, loading } = useQuery(GOOGLE_AUTHORIZATION_LINK_QUERY);

  return {
    data: getSingleProp(data),
    error,
    loading,
  };
};
